<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import LoggedOut from "@/layouts/LoggedOut.vue";
import { ref } from "vue";
import { useConfirmContactEmail } from "./contactEmailConfirmationCrud";

const props = defineProps<{
  token: string;
}>();

const showSuccessMessage = ref(false);

const { confirmContactEmail, confirmContactEmailStatus } =
  useConfirmContactEmail(props.token, {
    onSuccess: () => {
      showSuccessMessage.value = true;
    },
  });
</script>

<template>
  <LoggedOut>
    <h1>Bestätige deine E-Mail</h1>
    <form
      v-if="!showSuccessMessage"
      class="column"
      @submit.prevent="confirmContactEmail()"
    >
      <p>
        Bitte bestätige deine E-Mail-Adresse, damit wir dich erreichen können.
      </p>

      <SaveButton :saving-status="confirmContactEmailStatus"
        >E-Mail-Adresse bestätigen</SaveButton
      >
    </form>
    <p v-else>
      Vielen Dank! Deine E-Mail-Adresse wurde bestätigt. Wir werden dich
      kontaktieren, sobald es Neuigkeiten gibt.
    </p>
  </LoggedOut>
</template>

<style scoped>
button[type="submit"] {
  width: 100%;
  justify-content: center;
}
</style>
